export const DATEFORMAT = {
  yyyymmdd: 'yyyymmdd',
  ddmmyy: 'dd.mm.yy',
  doMMMMyyyy: 'do MMMM yyyy',
  EEEEdMMMM: "EEEE 'd.' d. MMMM",
  EEEEdMMMMyyyy: "EEEE 'd.' d. MMMM, yyyy",
};
